export var ETypeOfContact;
(function (ETypeOfContact) {
    ETypeOfContact["Call"] = "Calls";
    ETypeOfContact["Meeting"] = "In-Person";
    ETypeOfContact["Virtual"] = "Virtual";
})(ETypeOfContact || (ETypeOfContact = {}));
